import EditablePersianSupportTextField from 'Global/Components/EditableComponents/EditablePersianSupportTextField';
import MuiDatePicker from 'Global/Components/UnEditableComponents/MuiDatePicker/MuiDatePicker';
import React, { useState } from 'react';
import FileTypeCombo from './FileTypeCombo';
import i18next from 'i18next';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import PersianSupportTextField from 'Global/Components/UnEditableComponents/PersianSupportTextField/PersianSupportTextField';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { Button, LinearProgress } from '@mui/material';
import { AddPatientFileArchive } from '../Adapters/AddPatientFileArchive';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { closeUploadDrawer } from '../Shared/close.uploader.trigger';
import { useAtom } from 'jotai';

export default function FileInformation({
  fileSelected,
  formProps,
  setFromProps,
  enableSubmitBtn,
}) {
  const fileName_label = FindLangKey(
    'general-public-label-file-name'
  );
  const fileDate_prop = FindLangKey(
    'general-public-label-file-date'
  );
  const description_label = FindLangKey(
    'general-public-label-file-description'
  );
  const sendfile_label = FindLangKey(
    'main-menu-button-patient-send-file'
  );
  const sendfile_prompt = FindLangKey(
    'genral-public-label-send-file-prompt'
  );

  const [loading, setLoading] = useState(null);

  const [, setUploadDrawer] = useAtom(closeUploadDrawer);

  return (
    <>
      <EditablePersianSupportTextField
        disabled={true}
        label={fileName_label}
        Initialvalue={fileSelected?.fileName}
        isEnglish={i18next.language === 'en'}
        onChange={(val) => {
          setFromProps((prev) => ({
            ...prev,
            NameFile: val,
          }));
        }}
      />
      <MuiDatePicker
        Placeholder={fileDate_prop}
        isEnglish={i18next.language === 'en'}
        onChange={(val) => {
          setFromProps((prev) => ({
            ...prev,
            DateMadrak: val,
          }));
        }}
      />
      <FileTypeCombo setFromProps={setFromProps} />
      <PersianSupportTextField
        isEnglish={i18next.language === 'en'}
        label={description_label}
        onChange={(val) => {
          setFromProps((prev) => ({
            ...prev,
            Description: val,
          }));
        }}
      />
      <Button
        variant="contained"
        disabled={!enableSubmitBtn}
        color={'colorPrimer'}
        sx={{
          color: `${themeColors.ColorPrimary} !important`,
        }}
        onClick={() => {
          SwalAlert(
            'warning',
            sendfile_prompt,
            true,
            () => {
              AddPatientFileArchive(
                formProps,
                setLoading,
                setUploadDrawer
              );
            }
          );
        }}
      >
        {sendfile_label}
      </Button>
      {loading ? <LinearProgress /> : <></>}
    </>
  );
}
